import { intlFormat, isPast } from "date-fns";
import { ShipmentEvent } from "../shared/interfaces";
import { PACKAGE_DELIVERY } from "../shared/strings/constants";

interface FormatOptions{
    localeMatcher?: "lookup" | "best fit"
    weekday?: "narrow" | "short" | "long"
    era?: "narrow" | "short" | "long"
    year?: "numeric" | "2-digit"
    month?: "numeric" | "2-digit" | "narrow" | "short" | "long"
    day?: "numeric" | "2-digit"
    hour?: "numeric" | "2-digit"
    minute?: "numeric" | "2-digit"
    second?: "numeric" | "2-digit"
    timeZoneName?: "short" | "long"
    formatMatcher?: "basic" | "best fit"
    hour12?: boolean
    timeZone?: string
}

const getDeliveryMessage = (isDelivered: boolean, eddEpoch: number, lastestShipmentEvent: ShipmentEvent, logisticsMode: string, t: (key: string) => string) => {
    if(logisticsMode === PACKAGE_DELIVERY) {
        const dateFormatOptions : FormatOptions = {
            day: "2-digit",
            month: "short",
            year: "numeric"
        };
        if (isDelivered) {
            const formattedDate = intlFormat(Number(lastestShipmentEvent.eventTime), dateFormatOptions);
            return `${t("rttv_widget_delivered_at")} : ${formattedDate}`;
        }
        if (isPast(eddEpoch)) {
            return t("rttv_widget_arriving_late");
        }
        if(eddEpoch === 0) {
            return `${t("rttv_widget_arriving_on")} : ---`;
        }
        const formattedEdd = intlFormat(Number(eddEpoch), dateFormatOptions);
        return `${t("rttv_widget_arriving_on")} : ${formattedEdd}`;
    }
};

export default getDeliveryMessage;
